class StoreUserActionType {
  constructor (
    id = undefined,
    name
  ) {
    this.id = id
    this.name = name
  }

  toNormalizedRESTModel () {
    return ({
      // id is read-only
      // name is read-only
    })
  }

  static FromNormalizedRESTModel ({
    id,
    name
  }) {
    return new StoreUserActionType(
      id,
      name
    )
  }

  toJSON () {
    return {
      id: this.id,
      name: this.name
    }
  }

  static FromJSON ({
    id,
    name
  }) {
    return new StoreUserActionType(
      id,
      name
    )
  }
}

StoreUserActionType.TYPE_NAMES = {
  LOGIN: 'LOGIN'
}

export default StoreUserActionType
